import { createElement } from "react";
import type { ComponentType, SVGProps } from "react";
import { CustomTypography } from "sipli-fleet-core/components";
import type { ConnectivityHeatmapDay } from "src/services/connectivityHeatmapService";

export const CUSTOMERS_PAGINATION = {
  page: 0,
  size: 10,
};

export const CUSTOMERS_SORTING = {
  sortBy: "ID" as string | undefined,
  sortDir: "DESC" as "ASC" | "DESC" | undefined,
};

export const customerDataIndexToColumnId: Record<string, string> = {
  id: "ID",
  companyName: "COMPANY_NAME",
  name: "NAME",
  type: "CLIENT_TYPE",
  customerManager: "CLIENT_MANAGER",
  mail: "EMAIL",
  devices: "DEVICES_COUNT",
  sensors: "SENSORS",
  surname: "SURNAME",
  regNo: "REG_NO",
  vat: "VAT",
  bank: "BANK",
  swift: "SWIFT",
  accountNo: "ACCOUNT_NO",
  legalName: "LEGAL_NAME",
  personalCode: "PERSONAL_CODE",
  createdBy: "CREATED_BY",
  updateDate: "UPDATE_DATE",
  updatedBy: "UPDATED_BY",
  creationDate: "CREATION_DATE",
};

export const CUSTOMER_STATUS_OPTIONS = [
  {
    label: "active",
    value: "ACTIVE",
  },
  {
    label: "inactive",
    value: "INACTIVE",
  },
  {
    label: "blocked",
    value: "BLOCKED",
  },
];

export const CUSTOMER_STATUS_CONFIG: Record<string, { labelKey: string; className: string }> = {
  active: {
    labelKey: "active",
    className: "bg-[#e9f7ef] text-[#16794c]",
  },
  inactive: {
    labelKey: "inactive",
    className: "bg-[#f1f3f5] text-[#6b7280]",
  },
  blocked: {
    labelKey: "blocked",
    className: "bg-[#fdecec] text-[#b42318]",
  },
};

export const staticConnectivityData: ConnectivityHeatmapDay[] = [
  {
    day: "FRIDAY",
    date: "2026-06-12",
    slots: [
      {
        time: "00:00",
        delay: false,
        power: [false],
      },
      {
        time: "00:15",
        delay: true,
        power: [true],
      },
      {
        time: "00:30",
        delay: true,
        power: [false],
      },
      {
        time: "00:45",
        delay: false,
        power: [true],
      },
      {
        time: "01:00",
        delay: false,
        power: [false],
      },
      {
        time: "01:15",
        delay: false,
        power: [],
      },
      {
        time: "01:30",
        delay: false,
        power: [],
      },
      {
        time: "01:45",
        delay: false,
        power: [],
      },
      {
        time: "02:00",
        delay: false,
        power: [],
      },
      {
        time: "02:15",
        delay: false,
        power: [],
      },
      {
        time: "02:30",
        delay: false,
        power: [],
      },
      {
        time: "02:45",
        delay: false,
        power: [],
      },
      {
        time: "03:00",
        delay: false,
        power: [],
      },
      {
        time: "03:15",
        delay: false,
        power: [false],
      },
      {
        time: "03:30",
        delay: false,
        power: [],
      },
      {
        time: "03:45",
        delay: false,
        power: [],
      },
      {
        time: "04:00",
        delay: false,
        power: [true],
      },
      {
        time: "04:15",
        delay: false,
        power: [],
      },
      {
        time: "04:30",
        delay: false,
        power: [],
      },
      {
        time: "04:45",
        delay: false,
        power: [],
      },
      {
        time: "05:00",
        delay: false,
        power: [],
      },
      {
        time: "05:15",
        delay: false,
        power: [],
      },
      {
        time: "05:30",
        delay: false,
        power: [],
      },
      {
        time: "05:45",
        delay: false,
        power: [],
      },
      {
        time: "06:00",
        delay: false,
        power: [],
      },
      {
        time: "06:15",
        delay: false,
        power: [],
      },
      {
        time: "06:30",
        delay: false,
        power: [],
      },
      {
        time: "06:45",
        delay: false,
        power: [],
      },
      {
        time: "07:00",
        delay: false,
        power: [],
      },
      {
        time: "07:15",
        delay: false,
        power: [],
      },
      {
        time: "07:30",
        delay: false,
        power: [],
      },
      {
        time: "07:45",
        delay: false,
        power: [],
      },
      {
        time: "08:00",
        delay: false,
        power: [false],
      },
      {
        time: "08:15",
        delay: false,
        power: [],
      },
      {
        time: "08:30",
        delay: false,
        power: [],
      },
      {
        time: "08:45",
        delay: false,
        power: [],
      },
      {
        time: "09:00",
        delay: false,
        power: [],
      },
      {
        time: "09:15",
        delay: false,
        power: [],
      },
      {
        time: "09:30",
        delay: false,
        power: [],
      },
      {
        time: "09:45",
        delay: false,
        power: [],
      },
      {
        time: "10:00",
        delay: false,
        power: [],
      },
      {
        time: "10:15",
        delay: false,
        power: [],
      },
      {
        time: "10:30",
        delay: false,
        power: [],
      },
      {
        time: "10:45",
        delay: false,
        power: [],
      },
      {
        time: "11:00",
        delay: false,
        power: [],
      },
      {
        time: "11:15",
        delay: false,
        power: [],
      },
      {
        time: "11:30",
        delay: false,
        power: [],
      },
      {
        time: "11:45",
        delay: false,
        power: [],
      },
      {
        time: "12:00",
        delay: false,
        power: [],
      },
      {
        time: "12:15",
        delay: false,
        power: [],
      },
      {
        time: "12:30",
        delay: false,
        power: [],
      },
      {
        time: "12:45",
        delay: false,
        power: [],
      },
      {
        time: "13:00",
        delay: false,
        power: [true],
      },
      {
        time: "14:00",
        delay: false,
        power: [],
      },
      {
        time: "15:00",
        delay: false,
        power: [],
      },
      {
        time: "16:00",
        delay: false,
        power: [],
      },
      {
        time: "17:00",
        delay: false,
        power: [],
      },
      {
        time: "18:00",
        delay: false,
        power: [],
      },
      {
        time: "19:00",
        delay: false,
        power: [],
      },
      {
        time: "20:00",
        delay: true,
        power: [],
      },
      {
        time: "21:00",
        delay: false,
        power: [],
      },
      {
        time: "22:00",
        delay: false,
        power: [],
      },
      {
        time: "23:00",
        delay: true,
        power: [false],
      },
      {
        time: "24:00",
        delay: true,
        power: [false],
      },
    ],
  },
];

type SvgIcon = ComponentType<SVGProps<SVGSVGElement>>;

export const renderTabLabel = (Icon: SvgIcon | null, label: string, isActive: boolean) =>
  createElement(
    "div",
    { className: "flex items-center gap-2" },
    Icon
      ? createElement(Icon, {
          className: `customer-device-tab-icon ${
            isActive ? "customer-device-tab-icon-active" : "customer-device-tab-icon-inactive"
          }`,
        })
      : null,
    createElement(
      CustomTypography.CustomText,
      {
        className: `!text-[15.75px] !font-semibold ${isActive ? "!text-primary" : "!text-gray8"}`,
      },
      label
    )
  );
